// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { formatText,FormattedText } = require('core/i18n').i18n;
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');

const BrokerTableIndexesDetail = ({
    stocksIndex,
    buildArrowIcon
}) => {

    const bodyTable = () => {
        if (stocksIndex) {
            const tableBody = stocksIndex.map((stock, index) => {
                const arrow = buildArrowIcon(stock.netChangePrice.toFixed(2) < 0, 'indexes');
                return (
                    <OKTableRow key={index} modifier="inner-padding" className="broker-markets-index-detail__table-body">
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            <span onClick={() => this.buyStockIndex(stock.instrumentId)} className="broker-markets-index-detail__table-body__cell__name">{stock.name}</span>
                            <p className="broker-markets-index-detail__table-body__cell__isin">
                                {`${stock.category} - ISIN: ${stock.instrumentId}`}
                            </p>
                        </OKTableCell>
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            {arrow}
                            {stock.last}
                        </OKTableCell>
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            {stock.variationPts}
                        </OKTableCell>
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            {stock.high}
                        </OKTableCell>
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            {stock.low}
                        </OKTableCell>
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            {stock.volume}
                        </OKTableCell>
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            {stock.tradeTime}
                        </OKTableCell>
                        <OKTableCell className="broker-markets-index-detail__table-body__cell">
                            <OKButton modifier="secondary" onClick={() => this.buyStockIndex(stock.instrumentId)}>{ formatText('brokerMarketIndexes-buyButton') }</OKButton>
                        </OKTableCell>
                    </OKTableRow>
                )
            })

            return tableBody;
        }

        return null;
    }

    return (
        <OKTable>
            <thead>
                <OKTableRow asHeader={true} modifier="inner-padding" className="broker-markets-index-detail__table-header">
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title -left">
                        <FormattedText value="brokerMarketIndexes-valueTitle"/>
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title">
                        <FormattedText value="brokerMarketIndexes-lasTitle"/>
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title">
                        <FormattedText value="brokerMarketIndexes-variationTitle"/>
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title -right">
                        <FormattedText value="brokerMarketIndexes-maxTitle"/>
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title -right">
                        <FormattedText value="brokerMarketIndexes-minTitle"/>
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title -right">
                        <FormattedText value="brokerMarketIndexes-volumeTitle"/>
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title -right">
                        <FormattedText value="brokerMarketIndexes-hourTitle"/>
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-markets-index-detail__table-header__title -right">
                        <FormattedText value="brokerMarketIndexes-operationTitle"/>
                    </OKTableCell>
                </OKTableRow>
            </thead>
            <tbody>
                {bodyTable()}
            </tbody>
        </OKTable>
    )
}

BrokerTableIndexesDetail.propTypes = {
    buildArrowIcon: PropTypes.func,
    stocksIndex: PropTypes.object,
};

export { BrokerTableIndexesDetail };